<!-- 模板 -->
<template>
  <header class="header">
    <div class="wrap">
      <div class="logo">ARXene Database</div>
      <nav>
        <ul class="nav-list">
          <li v-for="link in links" :key="link.text">
            <router-link
              :to="link.path"
              active-class="active"
              :exact="link.path == '/'"
              >{{ link.text }}</router-link
            >
          </li>
        </ul>
      </nav>
    </div>
  </header>
</template>
<script>
// import request from '../utils/request.js'
import { mapState } from "vuex";
export default {
  name: "Header",
  data() {
    return {
      links: [
        { text: "Home", path: "/" },
        { text: "Search", path: "/search" },
        // { text: "User", path: "/feedback" },
      ],

      select: "1",
      searchInp: "",
    };
  },
  props: ["searchArr"],
  components: {},
  computed: {
    ...mapState(["isLoggedIn", "username"]),
  },
  filters: {},
  methods: {
    toPath(url) {
      this.$router.push(url);
    },
    // 监听搜索框内容变化
    searchInput() {
      this.$emit("edit:searchInp", this.searchInp);
    },
    // 填充Input输入框
    inputSr() {
      let inputArr = this.searchArr.map((element) => element.symbol);
      this.searchInp = inputArr.join("-");
    },
    logout() {
      this.$store.dispatch("logout"); // 调用 Vuex 的 logout 动作
    },
  },
  created() {},
  mounted() {},
  watch: {
    searchArr(newVal, oldVal) {
      this.inputSr();
    },
  },
};
</script>
<style lang="less">
header {
  // padding: 0 30px;
  background: #fff;
  .wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 80px;
  }
  .logo {
    color: #c41e3a;
    font-size: 34px;
  }
  .nav-list {
    display: flex;
    align-items: center;
    li {
      &:not(:last-child) {
        margin-right: 80px;
      }
      a {
        font-size: 18px;
        color: #707070;
        opacity: 0.5;
        height: 46px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 18px;
        border: 1px solid #fff;
        border-color: transparent;
        border-radius: 10px;
        transition: 0.3s;
        &.active {
          opacity: 1;
          font-weight: bold;
        }
        &:hover {
          opacity: 1;
          font-weight: bold;
        }
      }
    }
  }
  .header-right {
    .login-btn {
      width: 68px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #47e6dd;
      font-size: 16px;
      border-radius: 4px;
      transition: 0.3s;
      &:hover {
        opacity: 0.9;
      }
    }
    .loginin {
      display: flex;
      align-items: center;
      font-size: 16px;
      color: #fff;
      transition: 0.3s;

      span {
        cursor: pointer;
        &:hover {
          color: #00a0e9;
        }
      }
    }
    .exit-btn {
      width: 80px;
      height: 46px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: rgba(255, 255, 255, 0.8);
      font-size: 18px;
      border-radius: 10px;
      color: #fff;
      margin-left: 20px;
      cursor: pointer;
    }
  }
}
</style>
